import type { Configuration } from '@azure/msal-browser';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_CLIENT_ID,
    authority: 'https://login.microsoftonline.com/1d063515-6cad-4195-9486-ea65df456faa',
    // MSAL v5 routes every flow through a redirect bridge page that must not carry COOP
    // headers; it is a separate Vite entry, so this must stay off the SPA's own routes.
    redirectUri: '/redirect.html',
  },
};
